module.exports = __webpack_public_path__ + "img/progress_082.b61ba026.png";